<template>
    <div class="create-content">
        <h3>{{ $t('createContent.NEED_TO_ADD_MORE_CONTENT') }}</h3>
        <div>
            <span @click="createContent('HTML','ENUNCIADO')"><i class="material-icons">text_fields</i>{{ $t('createContent.STATEMENT') }}</span>
            <span @click="createContent('HTML','GENIALLY')"><i class="material-icons">web_asset</i>{{ $t('createContent.CONTENT') }}</span>
            <span :style="props.finalPractice ? 'opacity:.3; cursor:default' : ''"
                @click="props.finalPractice ? '' : createContent('ATTACH')"><i class="material-icons">grading</i>{{ $t('createContent.ACTIVITY') }}</span>
            <span @click="createContent('FORUM')"><i class="material-icons">forum</i>{{ $t('createContent.FORUM') }}</span>
            <span @click="createContent('COMMENTSWALL')"><i class="material-icons">table_chart</i>{{ $t('createContent.EXCHANGE') }}</span>
            <span @click="createContent('HTML','DIVISION')"><i class="material-icons">layers</i>{{ $t('createContent.DIVIDER') }}</span>
            <span @click="createContent('HTML','IMAGEN')"><i class="material-icons">image</i>{{ $t('createContent.IMAGE') }}</span>
            <span @click="createContent('HTML','ACCESO_DIRECTO')"><i class="material-icons">link</i>Redirección</span>
        </div>
    </div>
    
</template>

<script setup>
import { defineEmits, defineProps } from 'vue';


const props = defineProps({
    order: Number,
    finalPractice: String,
})
const emit = defineEmits(['create']);


const contentModel = {
    id: null,
    type: '',
    htmlType: null,
    orderNumber: props.order || null,
    isMandatory: true,
    data: {
        Data: '',
        Preview: ''
    }
}

const createContent = (type, htmlType=null) => {
    let model = JSON.parse(JSON.stringify(contentModel));
    model.type = type;
    model.htmlType = htmlType;
    if(model.type == 'HTML') delete model.data.Preview;
    emit('create', model);
}


</script>

<style lang="scss" scoped>
@import '@/styles/main.scss';

.create-content{
    width: 100%;
    max-width: 100%;
    padding: 24px 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    h3{
        padding-bottom: 18px;
        text-align: center;
        font-size: 16px;
        font-weight: 700;
        color: $darkgray;
    }
    >div{
        max-width: 100%;
        overflow-x: auto;
        padding: 4px 20px;
        display: flex;
        justify-content: center; //Sacar para mobile
        gap: 18px;
        border-radius: 10px;
        background: #FFF;
        box-shadow: 5px 5px 35px 0px rgba(217, 217, 217, 0.50);
    }
    span{
        padding: 12px 16px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 6px;
        cursor: pointer;
    }
}

</style>